import { IStockOrderDetail } from '../../../../../types/stockOrders';
import ProviderInfo from './components/ProviderInfo/ProviderInfo';
import RequestorInfo from './components/RequestorInfo/RequestorInfo';
import TrackingInfo from './components/TrackingInfo/TrackingInfo';

import './Tab1General.scss';

interface Tab1GeneralProps {
  stockOrderData: IStockOrderDetail;
  updateWithoutLoaders: () => Promise<void>;
  setSelectedTabId: (tabId: number) => void;
}

const Tab1General = ({ stockOrderData, updateWithoutLoaders, setSelectedTabId }: Tab1GeneralProps) => {
  const { generalData, orderId, country } = stockOrderData;
  const { requesterInfo, providerInfo, shipments } = generalData;

  return (
    <div className="tab1General">
      <div className="tab1GeneralFirstGroupContainer">
        <RequestorInfo requesterInfo={requesterInfo} />
        <ProviderInfo providerInfo={providerInfo} setSelectedTabId={setSelectedTabId} />
      </div>
      <div className="customDivider large" />
      <TrackingInfo shipments={shipments} orderId={orderId} updateWithoutLoaders={updateWithoutLoaders} country={country} />
    </div>
  );
};

export default Tab1General;
